import { FormGroup, ListItem, ListItemText } from "@mui/material"
import List from "@mui/material/List"
import { styled } from "@mui/material/styles"
import { sharedListItemStyle } from "shared/styled/General"

export const StyledWrapper = styled(List)({
  width: "100%",
  backgroundColor: "theme.palette.background.paper",
  padding: "4rem 2rem 2rem 2rem"
})

export const StyledHeading = styled(ListItem)(({ theme }) => ({
  display: "flex",
  width: "100%",
  maxWidth: 360,
  backgroundColor: theme.palette.background.paper,
  padding: "0 0 1rem 0"
}))

export const StyledTitle = styled(ListItemText)(({ theme }) => ({
  color: theme.palette.foreground.default,
  marginBottom: "0"
}))

export const StyledFormGroup = styled(FormGroup)(sharedListItemStyle)
